
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useQuestTypeDetail } from '@/modules/quest/type/model/detail';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.TYPE.DETAIL,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton },
    setup() {
        const { model, fetch, actions } = useQuestTypeDetail();

        onMounted(() => {
            fetch();
        });

        return { model, actions, displayTypeList, timeUnits };
    }
});

const displayTypeList = [
    { label: 'Special', value: 1, background: 'success' },
    { label: 'Normal', value: 0, background: 'info' }
];
